module.exports = __webpack_public_path__ + "static/media/img-exhibition-guide01.18282055.jpg";